import apiClient from './api';

const agreementService = {
  getAgreements: async (params) => {
    return apiClient.get('/agreements/', { params });
  },

  getAgreement: async (id) => {
    return apiClient.get(`/agreements/${id}`);
  },

  createAgreement: async (data) => {
    return apiClient.post('/agreements/', data);
  },

  signAgreement: async (id, data) => {
    return apiClient.post(`/agreements/${id}/sign`, data);
  },

  downloadAgreement: async (id, agreement) => {
    try {
      // If scanned_copy_url exists, open the uploaded file in new tab
      if (agreement?.scanned_copy_url) {
        const apiBase = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
        const serverUrl = apiBase.endsWith('/api') ? apiBase.slice(0, -4) : apiBase;
        const url = `${serverUrl}${agreement.scanned_copy_url}`;
        window.open(url, '_blank');
        return;
      }
      
      // Fallback to API download if no scanned copy
      const response = await apiClient.get(`/agreements/${id}/download`, {
        responseType: 'blob',
      });
      
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `agreement-${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download error:', err);
      throw err;
    }
  },

  uploadSignedCopy: async (id, formData) => {
    return apiClient.post(`/agreements/${id}/upload-signed-copy`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default agreementService;
